// NewMortgageLoanForm.js
import React, {useEffect, useState} from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';


const NewMortgageLoanForm = () => {
    const [bankLoanNumber, setBankLoanNumber] = useState(null);
    const [amortBool, setAmortBoolean] = useState(true);
    const [lenderChoices, setLenderChoices] = useState([]);
    const [selectedLender, setSelectedLender] = useState('');
    const [loanAmount, setLoanAmount] = useState(null);
    const [rateTypeChoices, setRateTypeChoices] = useState([]);
    const [selectedRateType, setSelectedRateType] = useState('');
    const [annualInterestRate, setAnnualInterestRate] = useState(null);
    const [originationDate, setOriginationDate] = useState(null);
    const [firstPaymentDate, setFirstPaymentDate] = useState(null);
    const [loanTermYears, setLoanTermYears] = useState(null);
    const [maturityDate, setMaturityDate] = useState(null);
    const [noPaymentsPerYear, setNoPaymentsPerYear] = useState(12);
    const [totalClosingCosts, setTotalClosingCosts] = useState(null);
    const [deedNumber, setDeedNumber] = useState(null);
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState(''); // Consider using state choices as discussed before.
    const [postalCode, setPostalCode] = useState('');
    const [propertyUseChoices, setPropertyUseChoices] = useState([]);
    const [selectedPropertyUse, setSelectedPropertyUse] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLenderChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/lender-choices/');
                setLenderChoices(response.data);
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchLenderChoices();
    }, []);

    useEffect(() => {
        const fetchRateTypeChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/rate-type-choices/');
                setRateTypeChoices(response.data);
            } catch (error) {
                console.error('Error fetching rate type choices:', error);
                setError('Failed to fetch rate type choices.');
            }
        };
        fetchRateTypeChoices();
    }, []);

    useEffect(() => {
        const fetchPropertyUseChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/property-use-choices/');
                setPropertyUseChoices(response.data);
            } catch (error) {
                console.error('Error fetching property use choices:', error);
                setError('Failed to fetch property use choices.');
            }
        };
        fetchPropertyUseChoices();
    }, []);

    // This function toggles the amortization boolean state
    const handleAmortToggle = () => {
        setAmortBoolean(!amortBool);
  };

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newMortgageData = {
            'bank_loan_number': bankLoanNumber,
            'amortizing': amortBool,
            'lender': selectedLender,
            'amount': loanAmount,
            'rate_type': selectedRateType,
            'initial_interest_rate': annualInterestRate,
            'origination_date': originationDate,
            'first_payment_date': firstPaymentDate,
            'loan_term_in_years': loanTermYears,
            'maturity_date': maturityDate,
            'n_payments_per_year': noPaymentsPerYear,
            'total_closing_costs': totalClosingCosts,
            'deed_number': deedNumber,
            'address':
                {
                    'street': street,
                    'city': city,
                    'state': state,
                    'postal_code': postalCode,
                    'property_use_type': selectedPropertyUse
                }

        }

        // if (titleDocument) {
        //     newMortgageData.append('title_document', titleDocument);
        // }

        // I think you will need to go through and create new "create" urls for each loan type, along with serializers
        try {
            const response = await axios.post('/api/balance_sheet/financing/mortgages/', newMortgageData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate(`/balance_sheet/assets/physical_assets/financing/mortgages/${response.data.id}/`);
            // setResiPropertyId(response.data.id);


            // Now you can toggle visibility for land and structure forms
        } catch (error) {
            console.error('Error creating new mortgage loan:', error);
            setError('There was an error creating the mortgage. Please check your input.');
        }
    };

  return (
        <div className="container mt-4" style={{marginBottom: '20px'}}>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Amortizing Loan:
                    </label>
                    <input
                        type="checkbox"
                        checked={amortBool}
                        onChange={handleAmortToggle}
                        className="ml-2"
                        style={{ marginLeft: '15px', verticalAlign: 'middle' }} // This ensures the checkbox aligns nicely with the label
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="lender" className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>Lender:</label>
                    <select
                        id="lender"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedLender}
                        onChange={(e) => setSelectedLender(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a lender</option>
                        {lenderChoices.map(([id, name]) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Bank Loan
                        Number:</label>
                    <input
                        type="number"
                        value={bankLoanNumber}
                        onChange={(e) => setBankLoanNumber(parseInt(e.target.value, 10))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan
                        Amount:</label>
                    <input
                        type="number"
                        value={loanAmount}
                        onChange={(e) => setLoanAmount(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="rateType" className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>Interest Rate Type:</label>
                    <select
                        id="rateType"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedRateType}
                        onChange={(e) => setSelectedRateType(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a rate type</option>
                        {rateTypeChoices.map(([value, label]) => (
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Annual
                        Interest Rate (%):</label>
                    <input
                        type="number"
                        value={annualInterestRate}
                        onChange={(e) => setAnnualInterestRate(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Number of
                        Payments (per year):</label>
                    <input
                        type="number"
                        value={noPaymentsPerYear}
                        onChange={(e) => setNoPaymentsPerYear(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Origination
                        Date:</label>
                    <input
                        type="date"
                        value={originationDate ? originationDate : ""}
                        onChange={(e) => setOriginationDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>First
                        Payment Date:</label>
                    <input
                        type="date"
                        value={firstPaymentDate ? firstPaymentDate : ""}
                        onChange={(e) => setFirstPaymentDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan Term
                        (Years):</label>
                    <input
                        type="number"
                        value={loanTermYears}
                        onChange={(e) => setLoanTermYears(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Maturity
                        Date:</label>
                    <input
                        type="date"
                        value={maturityDate ? maturityDate : ""}
                        onChange={(e) => setMaturityDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan Closing Costs</label>
                    <input
                        type="number"
                        value={totalClosingCosts}
                        onChange={(e) => setTotalClosingCosts(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Deed
                        Number:</label>
                    <input
                        type="number"
                        value={deedNumber}
                        onChange={(e) => setDeedNumber(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Street
                        Address:</label>
                    <input
                        type="text"
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>City:</label>
                    <input
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>State:</label>
                    <input
                        type="text"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Postal
                        Code:</label>
                    <input
                        type="text"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="propertyUse" className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>Property Use Type:</label>
                    <select
                        id="propertyUse"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedPropertyUse}
                        onChange={(e) => setSelectedPropertyUse(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a property use</option>
                        {propertyUseChoices.map(([value, label]) => (
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </select>
                </div>

            <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
            </form>

            {error && <div className="text-danger">{error}</div>} {/* Display error messages */}
        </div>
    );
};

export default NewMortgageLoanForm;